export abstract class ZendeskWebwidgetConfig {
  abstract accountUrl: string;
  abstract beforePageLoad(zE): any;
}
